import {z} from 'zod';

export const materialDiscountFormSchema = z.object({
  name: z.string(),
  warehouseId: z.string(),
  supplierDiscountGroupId: z.array(z.string()),
  discountType: z.enum(['DISCOUNT_SALE_PRICE', 'DISCOUNT_PURCHASE_PRICE']),
  discountRatio: z.number().min(0).max(100),
});

export type MaterialDiscountFormType = z.infer<typeof materialDiscountFormSchema>;
